import React from 'react';
import UserForm from './UserForm';

const EditUser = ({ user, handleCloseEditModal, onUpdateSuccess }) => {
  return (
    <UserForm
      mode="edit"
      user={user}
      handleCloseModal={handleCloseEditModal}
      onSuccess={onUpdateSuccess}
    />
  );
};

export default EditUser;
